import { Link } from "react-router-dom";

function Physicslab() {
  return (
    <>
      <div className="innerslide py-3 bg-light border-bottom">
        <ul className="breadcrumb container mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item"> Facilities</li>
          <li className="breadcrumb-item active"> Physics Lab</li>
        </ul>
      </div>
      <div className="innersec container my-5">
        <div className="row g-3">
          <div class="col-lg-12">
            <h1> Physics Lab </h1>
            <p>
              The Physics Lab at The Frank Anthony Junior School, Bangalore, is
              a well-equipped space designed to help students explore the
              fascinating world of physics through hands-on experiments. The lab
              includes instruments for studying mechanics, optics, electricity,
              magnetism, and sound. Students get the opportunity to perform
              experiments that enhance their understanding of concepts learned
              in the classroom, develop scientific thinking, and improve
              problem-solving skills. The lab is maintained with safety in mind,
              and teachers guide students to carry out experiments carefully and
              accurately. Overall, the Physics Lab provides a practical
              environment where learning comes alive, making complex concepts
              easier to understand and sparking curiosity in young minds.
            </p>
          </div>
        </div>
        <br />

        <div className="row g-3 facilities_section_imgs">
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/p1.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>

          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/p2.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/p3.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
          <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
            <img
              src="https://webapi.entab.info/api/image/FAJUNIORSB/public/Images/p4.jpg"
              alt="Frank Anthony Bangalore"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
    </>
  );
}
export default Physicslab;
